import { api } from "constants/RotasAPI";
import useFetch from "hooks/useFetch";
import { toast } from "react-hot-toast";
import { informacoesAgendamentoDTO } from "types/dto/InformacoesAgendamentoDTO";

export const useGetInformacoesAgendamento = () => {
  const onError = () => {
    toast.error("Erro ao buscar as informações do agendamento");
  };

  return useFetch<informacoesAgendamentoDTO>({
    key: ["informacoes-agendamento"],
    url: api.agendamentoContato.getInformacoesAgendamento,
    onError,
  });
};
